import React from 'react';

const LCVTopBar = ({metadata}) => {
  return (
    <div className="lcv-top-bar">
      <div className="lcv-course-badge">
        <span className="lcv-course-label">[unit] &bull; {metadata?.subject || '[subject]'}</span>
        <span className="lcv-course-title">{metadata?.topic || '[topic]'}</span>
        <span className="lcv-course-lesson">[lessonNumber] of [totalLessons] &bull; {metadata?.lexileBand || ''} ({metadata?.lexileLevel || ''})</span>
      </div>
    </div>
  );
};

export default LCVTopBar;
